export default "__VITE_ASSET__1a954742__"